import { Stack, Box } from '@chakra-ui/react';
import type { Dispatch, SetStateAction } from 'react';
import { Empty } from '@halo/ui-chat-react';
import { all, isEmpty, entries } from 'lodash/fp';
import type { SearchTabs, SearchResults } from './helpers';
import { ExtraElement, ResultTopContacts } from './ResultContacts';
import { ResultsTopGroups } from './ResultsByGroup';
import SearchHistory from './SearchHistory';
import { ResultTopMessage } from './ResultMessages';
import Contacts from './Contacts';
import RecentSessions from './RecentSessions';

interface ResultTopResultsProps {
  searchValue: string;
  searchResults: SearchResults;
  setActive: Dispatch<SetStateAction<SearchTabs>>;
  onSearch: (val: string) => void;
  active: SearchTabs;
}

const ResultTopResults = ({
  searchResults,
  searchValue,
  setActive,
  onSearch,
  active,
}: ResultTopResultsProps) => {
  const isShowEmpty = useMemo(() => {
    return all(([_, item]) => isEmpty(item), entries(searchResults)) && searchValue;
  }, [searchResults, searchValue]);

  return (
    <Stack className="fadeIn" gap="2">
      <SearchHistory onSearch={onSearch} active={active} />

      {isShowEmpty ? (
        <Empty className="fadeIn" />
      ) : (
        <Box>
          {/*contacts result*/}
          <ResultTopContacts searchResults={searchResults} setActive={setActive} />

          {/*group result*/}
          <ResultsTopGroups searchResults={searchResults} setActive={setActive} />

          {/*message result*/}
          <ResultTopMessage
            searchResults={searchResults}
            setActive={setActive}
            searchValue={searchValue}
          />
        </Box>
      )}

      {/* Contacts */}
      <Contacts />
      {/*  Recent sessions */}
      <RecentSessions />

      <ExtraElement searchValue={searchValue} setActive={setActive} />
    </Stack>
  );
};

const MemoResultTopResults = memo(ResultTopResults);

export { MemoResultTopResults as ResultTopResults };
